import React, { useEffect } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, FontIcon, Grid } from 'react-md'

import { Cell, PageTitle, ButtonSuccess } from 'components/core'
import { handleSubmit, Input, Select } from 'components/form'
import { EquipmentTypeOptions } from 'types/inventory/maintenance-schedule'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })

  useEffect(() => {
    document.title = 'Nova Agenda de Manutenção'
  }, [])

  return (
    <Grid>
      <Cell>
        <PageTitle title='Nova Agenda de Manutenção' />
        <Card fullWidth>
          <CardContent>
            <FormContext {...form}>
              <Grid>
                <Input name='description' label='Descrição *' desktopSize={4} tabletSize={4} />
                <Select name='equipmentType' label='Tipo de Equipamento *' options={EquipmentTypeOptions} desktopSize={2} tabletSize={4} />
                <Input name='observation' label='Observação' desktopSize={6} tabletSize={8} />
              </Grid>
            </FormContext>
          </CardContent>
          <CardActions>
            <ButtonSuccess
              text='Salvar'
              icon={<FontIcon>done</FontIcon>}
              disabled={!form.formState.dirty}
              onClick={async () =>
                await handleSubmit(form, validationSchema, async () => {
                  let res = await handleSave(form.getValues())
                  if (res?.success) {
                    form.reset(defaultValues, { dirty: false })
                    window.open(`/inventory/maintenance-schedule/edit/${res.data}`, '_self')
                  }
                })
              }
            />
          </CardActions>
        </Card>
      </Cell>
    </Grid>
  )
}

export default Component
